import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

export default function StationModeSettings() {
  const [mode, setMode] = useState('multi');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    axios.get(`${API}/app-settings`).then(({ data }) => {
      if (active) { setMode(data.department_mode || 'multi'); setLoading(false); }
    }).catch(() => { if (active) setError('Einrichtungsmodus konnte nicht geladen werden. Bitte die Seite neu laden.'); });
    return () => { active = false; };
  }, []);
  const save = async () => {
    setSaving(true); setError(''); setMessage('');
    try {
      const { data } = await axios.post(`${API}/developer/app-settings`, { department_mode: mode });
      window.APP_CONFIG = { ...window.APP_CONFIG, department_mode: data.department_mode };
      window.dispatchEvent(new Event('focus'));
      setMessage('Einrichtungsmodus gespeichert.');
    } catch (failure) {
      setError(typeof failure.response?.data?.detail === 'string' ? failure.response.data.detail : 'Speichern fehlgeschlagen.');
    } finally { setSaving(false); }
  };
  return <section className="bg-white p-4 sm:p-6 rounded-lg shadow-sm mb-6">
    <h4 className="text-lg font-semibold text-gray-800 mb-3">Einrichtungsmodus</h4>
    <p className="text-sm text-gray-600 mb-4">Bei einer einzelnen Abteilung entfallen andere WA und abteilungsübergreifende Funktionen. Essen- und Getränkekonten bleiben erhalten.</p>
    <label className="block text-sm font-medium mb-2" htmlFor="station-mode">Organisation</label>
    <select id="station-mode" value={mode} disabled={loading || saving} onChange={event => setMode(event.target.value)} className="border rounded-lg p-2 mr-3">
      <option value="multi">Mehrere Wachabteilungen</option><option value="single">Eine Wachabteilung</option>
    </select>
    <button type="button" disabled={loading || saving} onClick={save} className="bg-red-700 text-white rounded-lg px-4 py-2 disabled:opacity-50">{saving ? 'Speichert …' : 'Speichern'}</button>
    <p className="text-xs text-gray-500 mt-3">Einzelabteilungsmodus ist nur bei genau einer angelegten Abteilung möglich. Das Ausblenden weiterer Logins genügt nicht.</p>
    {message && <p role="status" className="text-green-700 mt-3">{message}</p>}
    {error && <p role="alert" className="text-red-700 mt-3">{error}</p>}
  </section>;
}
